import { initNavbar } from "./navbar";
import { initSlider } from "./slider";
import { initAccordion } from "./accordion";

function run() {
  initNavbar();
  initSlider();
  initAccordion();
}

if (document.readyState === "loading") {
  document.addEventListener("DOMContentLoaded", run, { once: true });
} else {
  run();
}
document.addEventListener("astro:page-load", run);
